import { CheckCircle2 } from "lucide-react";

export const t12 = (t) => { if (!t) return null; const [h, m, sec] = t.split(":").map(Number); return `${h % 12 || 12}:${String(m).padStart(2, "0")}${sec === undefined ? "" : ":" + String(sec).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };
export const todayIST = () => new Date(Date.now() + 5.5 * 3600e3).toISOString().slice(0, 10);
export const curMonth = () => todayIST().slice(0, 7);

const BADGE = "inline-flex items-center gap-1 text-[10px] tracking-[0.12em] uppercase border px-2 py-0.5 whitespace-nowrap";
const STYLE = {
  full: "text-emerald-300 border-emerald-500/50 bg-emerald-500/10",
  late: "text-orange-300 border-orange-500/50 bg-orange-500/10",
  half: "text-yellow-300 border-yellow-500/50 bg-yellow-500/10",
  absent: "text-red-300 border-red-500/50 bg-red-500/10",
  leave: "text-sky-300 border-sky-500/50 bg-sky-500/10",
  off: "text-slate-400 border-white/15",
  working: "text-teal-200 border-teal-400/50 bg-teal-500/10",
  wfh: "text-violet-200 border-violet-400/50 bg-violet-500/10",
  muted: "text-slate-600 border-white/10",
};

/** Maps an engine row ({status, late, note, permitted_*}) to a {key, label} pair. */
export const attLabel = (r, weeklyOff = "Sunday") => {
  if (!r) return { key: "muted", label: "—" };
  if (r.wfh && ["present", "working", "half_day"].includes(r.status)) {
    if (r.status === "working") return { key: "wfh", label: r.late ? "WFH · Late" : "WFH" };
    if (r.status === "half_day") return { key: "half", label: "WFH · Half Day" };
    return r.late ? { key: "late", label: "WFH · Late" } : { key: "wfh", label: "WFH · Full Day" };
  }
  switch (r.status) {
    case "present": return r.late ? { key: "late", label: "Late" } : { key: "full", label: r.half_holiday ? "Half Day Holiday · Worked" : "Full Day" };
    case "half_day": return { key: "half", label: "Half Day" };
    case "absent": return { key: "absent", label: "Absent" };
    case "leave": return { key: "leave", label: "On Leave" };
    case "lwp": return { key: "leave", label: "On Leave (LOP)" };
    case "off": return { key: "off", label: r.note && !r.note.startsWith(weeklyOff) ? "Holiday" : "Weekly Off" };
    case "half_holiday": return { key: "off", label: "Half Day Holiday" };
    case "not_joined": return { key: "muted", label: "Not joined" };
    case "no_data": return { key: "muted", label: "No device data" };
    case "working": return { key: "working", label: r.late ? "In office · Late" : "In office" };
    case "future": return { key: "muted", label: "—" };
    default: return { key: "muted", label: r.status || "—" };
  }
};

export const AttBadge = ({ r, weeklyOff, testId }) => {
  const { key, label } = attLabel(r, weeklyOff);
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <span className={`${BADGE} ${STYLE[key]}`} data-testid={testId}>{key === "full" && <CheckCircle2 size={11} />}{label}</span>
      {(r?.permitted_late || r?.permitted_early) && <span className={`${BADGE} text-nx-goldlight border-nx-gold/50 bg-nx-gold/10`} data-testid={`${testId}-permitted`} title={r.note}>Permitted by HR</span>}
      {r?.override && <span className={`${BADGE} ${STYLE.off}`} title={r.note}>Corrected</span>}
      {r?.external && <span className={`${BADGE} text-sky-200 border-sky-400/50 bg-sky-400/10`} data-testid={`${testId}-external`} title={r.note}>External work</span>}
      {r?.edited && !r?.external && <span className={`${BADGE} ${STYLE.off}`} data-testid={`${testId}-edited`} title={r.note}>Edited by HR</span>}
    </span>
  );
};

export const Stat = ({ label, value, tone = "text-white", testId }) => (
  <div className="border border-white/10 bg-white/[0.02] px-3 py-2 min-w-[110px]" data-testid={testId}>
    <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`text-lg font-semibold ${tone}`}>{value}</div>
  </div>
);
